module.exports = __webpack_public_path__ + "static/media/application_cluster.74c57fff.svg";